import React from 'react';
import { Button, TextContent } from '../../components';
import { social } from '../../constants';

import styles from './LoginDialog.module.css';
import icClose from '../../assets/ic-close.svg';
import TNCFooter from './TNCFooter';

const TNCConfirmDialog = ({
  onClose,
  onClickFacebook,
  onClickGoogle,
  onClickTNC,
  type,
  dialogstate,
}) => {
  return (
    <div className={styles['container']}>
      <h2>
        {dialogstate} With {type}
      </h2>
      <TNCFooter dialogstate={dialogstate} onClick={onClickTNC} />
      <div className={styles['buttonWrapper']}>
        <Button
          onClick={() => {
            onClose();
            if (type === 'Google') {
              onClickGoogle();
            } else {
              onClickFacebook();
            }
          }}
          shape='rounded'
          size='large'
          width='100%'
        >
          Agree
        </Button>
        <Button
          onClick={() => {
            onClose();
          }}
          shape='rounded'
          color='dark'
          size='large'
          width='100%'
          textColor='#F49832'
        >
          Cancel
        </Button>
      </div>
    </div>
  );
};

export default TNCConfirmDialog;
